// Automatically injected by Vite define at build/dev server time, fallback to runtime Date
declare const __BUILD_TIMESTAMP__: string;

export function getFormattedLastUpdate(language: string = "en"): string {
  let dateObj: Date;
  try {
    if (typeof __BUILD_TIMESTAMP__ !== "undefined" && __BUILD_TIMESTAMP__) {
      dateObj = new Date(__BUILD_TIMESTAMP__);
    } else {
      dateObj = new Date();
    }
  } catch {
    dateObj = new Date();
  }

  if (isNaN(dateObj.getTime())) {
    dateObj = new Date();
  }

  const year = dateObj.getUTCFullYear();
  const month = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getUTCDate()).padStart(2, "0");
  const hours = String(dateObj.getUTCHours()).padStart(2, "0");
  const minutes = String(dateObj.getUTCMinutes()).padStart(2, "0");

  if (language === "hr") {
    return `ZADNJI UPDATE // ${day}.${month}.${year}. ${hours}:${minutes} UTC`;
  }
  return `LAST UPDATE // ${year}-${month}-${day} ${hours}:${minutes} UTC`;
}
